/** The planner's standard teams — the ones with team pages (Sidebar →
 *  All Teams). Always offered in team pickers, even before anyone on the
 *  roster is assigned; keep in sync with STANDARD_TEAMS in
 *  backend/engines/connector/teams.py. */
export const STANDARD_TEAMS = ["Synnergie", "Systems Applications", "Business Analysts"] as const;

/** Standard teams plus any others in use, de-duplicated case-insensitively. */
export function teamOptions(inUse: Iterable<string | null | undefined>): string[] {
  const byKey = new Map<string, string>();
  for (const t of [...STANDARD_TEAMS, ...inUse]) {
    const name = (t ?? "").trim();
    if (name && !byKey.has(name.toLowerCase())) byKey.set(name.toLowerCase(), name);
  }
  return [...byKey.values()].sort((a, b) => a.localeCompare(b));
}
